import {
  BlockNodes,
  initRawSchema,
  NodeSchema,
  RawInlineNodes,
} from '@principle-theorem/editor';
import {
  ConditionLogic,
  IPatientHasEmailAddressConditionConfig,
  IPatientHasMobileNumberConditionConfig,
} from '@principle-theorem/principle-core';
import {
  AutomatedNotificationType,
  ConditionLogicConfigurationCollection,
  ConditionLogicId,
  IAutomatedNotification,
  IAutomationTiming,
  IConditionLogicConfiguration,
  TimingDirection,
  TimingUnit,
} from '@principle-theorem/principle-core/interfaces';

export class MarketingCampaignTemplateFactory {
  static automationSMS(
    content: string | string[] | NodeSchema<BlockNodes>[] | RawInlineNodes,
    timing?: IAutomationTiming,
    conditions?: ConditionLogicConfigurationCollection
  ): IAutomatedNotification {
    return {
      name: '',
      type: AutomatedNotificationType.SMS,
      subject: '',
      customTemplate: {
        content: initRawSchema(content),
      },
      timing: timing ?? {
        direction: TimingDirection.Immediately,
        amount: 0,
        unit: TimingUnit.Minutes,
      },
      requiredConditions:
        conditions ??
        ConditionLogic.collection([
          ConditionLogic.and([ConditionLogic.always()]),
        ]),
    };
  }

  static automationEmail(
    subject: string,
    content: string | string[] | NodeSchema<BlockNodes>[] | RawInlineNodes,
    timing?: IAutomationTiming,
    conditions?: ConditionLogicConfigurationCollection
  ): IAutomatedNotification {
    return {
      name: '',
      type: AutomatedNotificationType.EMAIL,
      subject,
      customTemplate: {
        content: initRawSchema(content),
      },
      timing: timing ?? {
        direction: TimingDirection.Immediately,
        amount: 0,
        unit: TimingUnit.Minutes,
      },
      requiredConditions:
        conditions ??
        ConditionLogic.collection([
          ConditionLogic.and([ConditionLogic.always()]),
        ]),
    };
  }

  static conditions(
    conditions?: IConditionLogicConfiguration<unknown>[]
  ): ConditionLogicConfigurationCollection {
    return ConditionLogic.collection([ConditionLogic.and(conditions)]);
  }

  static conditionHasEmail(
    hasEmailAddress: boolean = true
  ): IConditionLogicConfiguration<IPatientHasEmailAddressConditionConfig> {
    return ConditionLogic.custom<IPatientHasEmailAddressConditionConfig>(
      ConditionLogicId.PatientHasEmailAddress,
      { hasEmailAddress }
    );
  }

  static conditionHasMobile(
    hasMobileNumber: boolean = true
  ): IConditionLogicConfiguration<IPatientHasMobileNumberConditionConfig> {
    return ConditionLogic.custom<IPatientHasMobileNumberConditionConfig>(
      ConditionLogicId.PatientHasMobileNumber,
      { hasMobileNumber }
    );
  }
}
